<template>

  <div class="shadow overflow-hidden">
    <div>
      <dl>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('academicyear.date') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ retirement.date }}
          </dd>
        </div>

        <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('vaccines.description') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ retirement.remarks }}
          </dd>
        </div>

      </dl>

    </div>

  </div>

</template>
<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from 'vue'
export default {
  name: 'ClassForm',
  components: {

  },
  props: {
    propObject: {
        type: Object,
        default: () => ({ empty: true })
    }
  },
  data: function () {
    return {
    }
  },
  emits: ['close-modal', 'submit'],
  setup (props, { emit }) {
    const titleStack = ref(['Admin', 'Forms'])

    const retirement = reactive({})

    watchEffect(() => {
      const newClass = props.propObject
      Object.assign(retirement, newClass)
    })

    return {
      titleStack,
      retirement

    }
  }
}
</script>